import { Component, OnInit, Input } from '@angular/core';
import { Validators, AbstractControl, FormGroup, FormControl, FormBuilder, FormArray, UntypedFormGroup, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { NgbCalendar, NgbDatepickerConfig, NgbDate, NgbDatepickerI18n, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { swalError, swalSuccess, swalInfo, swalDesition } from '../../shared/config/swalCommon';
import { numberIntMask, phoneMask, cellularMask, ciiuMask, numberCMask, numberPMask, nameMask,wordMask, onlyNumberMask, quotaMask, contractMask } from '../../shared/config/imaskCommon';
import { EMAIL_PATTERN, getValueSum, isValidForm } from '../../shared/config/config';
import { setDate, setDateStructure } from '../../shared/config/dateCommon';
import {
  I18n, CustomDatepickerI18n, DateFormatService, ValueService,
  PaymentCapacityService, UserService, PersonaService, LogsService
} from '../../services/services.index';
import { Value, Department, City, Reference, PaymentCapacity, User, AdjudgedInfo, People, Petition, Direction, FGCapacidadPago, LogsNav } from '../../interfaces/interfaces.index';
import { equalFields } from 'src/app/helpers/equalFields.validator';
import { findPetitionCoDebtor, loadForm, saveForm, stringAddressToObj } from 'src/app/shared';
import { catchError, delay, firstValueFrom, map, Observable, of } from 'rxjs';

@Component({
  selector: 'app-capacidad-pago',
  templateUrl: './capacidad-pago.component.html',
  styleUrls: ['./capacidad-pago.component.css'],
  styles: [`
    .card-footer { border-radius: 2rem 2rem 2rem 2rem !important; }
  `],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateParserFormatter, useClass: DateFormatService }
  ]
})
export class CapacidadPagoComponent implements OnInit {

  loadValues: boolean;
  values: Value[] = [];
  tr: Value[] = [];
  tp: Value[] = [];
  td: Value[] = [];
  s: Value[] = [];
  ec: Value[] = [];
  na: Value[] = [];
  tv: Value[] = [];
  ese: Value[] = [];
  act: Value[] = [];
  emp: Value[] = [];
  tc: Value[] = [];
  c: Value[] = [];
  sa: Value[] = [];
  a: Value[] = [];
  r: Value[] = [];
  tcs: Value[] = [];
  n: Value[] = [];
  p: Value[] = [];
  ar: Value[] = [];
  ca: Value[] = [];
  e: Value[] = [];
  pa: Value[] = [];
  ef: Value[] = [];
  df: Value[] = [];
  ci: Value[] = [];
  d: Department[] = [];
  c1: City[] = [];
  c10: City[] = [];
  l1: Value[] = [];
  c2: City[] = [];
  l2: Value[] = [];
  c3: City[] = [];
  l3: Value[] = [];
  c4: City[] = [];
  c40: City[] = [];
  c41: City[] = [];
  c42: City[] = [];
  c5: City[] = [];
  l5: Value[] = [];
  mostrar: boolean;
  hoy: NgbDate;
  hoy18: NgbDate;
  email_pattern = EMAIL_PATTERN;
  numberIntMask = numberIntMask;
  currencyMask = numberCMask;
  phoneMask = phoneMask;
  cellularMask = cellularMask;
  otherMask;
  ciiuMask = ciiuMask;
  percentMask = numberPMask;
  references: Reference[] = [];
  existeReferencia: boolean;
  paymentCapacity: PaymentCapacity;
  @Input() idPC: number;
  @Input() modal = false;
  userLogged: User;
  n15 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  preLoad = false;
  adjudged: People;
  adjudgedInfo: AdjudgedInfo;
  actPetition: Petition;
  phoneNumDigits = "";
  apellidos: string[];
  apellido1: string;
  apellido2: string[];
  minDate;
  pattern = '^[a-zA-Z0-9]+$';
  direcciones: any[] = [];
  add: string;
  add1: string;
  add2: string;
  add3: string;
  add31: string;
  add32: string;
  add4: string;
  valueBolean: boolean[] = [true,false];
  forma: FGCapacidadPago;
  nameMask = nameMask;
  wordMask=wordMask;
  onlyNumberMask = onlyNumberMask;
  hoyNbStruct: NgbDateStruct;
  paises: Value[] = [];
  resetThirdPerson = true;
  formSubmitted = false;
  saveForm = saveForm;
  formIdentifier = "formSaved";
  isSecondHolder = false;
  actualUser: User;
  emailPattern = EMAIL_PATTERN;
  contractMask = contractMask;
  quotaMask = quotaMask;
  loadFromStogare:boolean=false;
  constructor(
    public router: Router,
    private fb: FormBuilder,
    private valueService: ValueService,
    public dpConfig: NgbDatepickerConfig,
    public calendar: NgbCalendar,
    private paymentCapacityService: PaymentCapacityService,
    private spinnerService: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private personaService: PersonaService,
    private logService: LogsService,
    private userServices: UserService
  ) {

    this.userLogged = this.userService.user;
    this.hoy = calendar.getToday();
    this.hoyNbStruct = {year: this.hoy.year, month: this.hoy.month, day: this.hoy.day};
    this.hoy18 = new NgbDate(this.hoy.year - 18, this.hoy.month, this.hoy.day);
    this.minDate = {year: 1940, month: 1, day: 1};
    dpConfig.maxDate = { year: 2099, month: 12, day: 31 };
    dpConfig.firstDayOfWeek = 7;

    this.actPetition = (JSON.parse(sessionStorage.getItem('selPetition'))) as Petition;
    this.getValues();
    if(this.userService.user.id === this.actPetition.secondHolder?.userId) this.isSecondHolder = true;
    this.actualUser = this.userServices.user;

    this.forma = this.fb.group({
      id: [null as number | null],
      startDate: [this.hoy],
      transfer: ['No', Validators.required],
      role: [null as string | null, Validators.required],
      debtor: [null as string | null, Validators.required],
      contractNumber: [null as string | null, Validators.required],
      quotaNumber: [null as string | null, Validators.required],
      name: [null as string | null, Validators.required],
      lastName: [null as string | null, Validators.required],
      surname: [null as string | null],
      typeOfIdentity: ['CC', Validators.required],
      documentNumber: [null as string | null, Validators.required],
      expeditionDate: [null as NgbDateStruct, Validators.required],
      expeditionDepartment: [null as string | null, Validators.required],
      expeditionCity: [null as string | null, Validators.required],
      sex: [null as string | null, Validators.required],
      dateOfBirth: [null as NgbDateStruct | null, Validators.required],
      nationality: ['1', Validators.required],
      civilStatus: [null as string | null, Validators.required],
      academicLevel: [null as string | null, Validators.required],
      profession: [null as string | null],
      otherProfession: [null as string | null],
      minorLoad: [null as number | null, Validators.required],
      higherLoad: [null as number | null, Validators.required],
      housing: [null as string | null, Validators.required],
      rent: [null as string | null, Validators.required],
      address: this.fb.group({
        inlineAddress: [null as string | null, Validators.required],
      }),
      country: ["Colombia", Validators.required],
      department: [null as string | null, Validators.required],
      city: [null as string | null],
      cityOtherCountries: [null as string | null],
      location: [null as string | null],
      stratum: [null as string | null, Validators.required],
      yearsResidence: [null as string | null, Validators.required],
      phone: [null as string | null, {
        validators: [Validators.required, Validators.minLength(10)],
        updateOn: 'blur'
      }],
      cellular: [null as string | null, {
        validators: [Validators.required, Validators.minLength(10)],
        updateOn: 'blur'
      }],
      email: [null as string | null, {
        validators: [Validators.required,Validators.email, Validators.pattern(EMAIL_PATTERN)],
        updateOn: 'blur'
      }],
      emailAlt: [null as string | null, {
        validators: [Validators.email,Validators.pattern(EMAIL_PATTERN)],
        updateOn: 'blur'
      }],


      name1: [null as string | null],
      lastName1: [null as string | null],
      surname1: [null as string | null],
      typeOfIdentity1: ['CC'],
      documentNumber1: [null as string | null],
      dateOfBirth1: [null as NgbDateStruct | null],
      sex1: [null as string],
      chevyPlan1: [null],
      address1: this.fb.group({
        street: [null as string | null],
        streetNumber: [null as string | null],
        houseNumber: [null as string | null],
        oficeNumber: [null as string | null],
        apartment: [null as string | null],
        apartmentNumber: [null as string | null],
        neighborhood: [null as string | null],
        neighborhoodField: [null as string | null]
      }),
      department1: [null as string | null],
      city1: [null as string | null],
      location1: [null as string | null],
      phone1: [null as string | null, { updateOn: 'blur' }],
      cellular1: [null as string | null, { updateOn: 'blur' }],
      activities1: [null as string | null],
      ciiu: [null as string | null, Validators.required],
      job: [null as string | null, Validators.required],
      whichJob: [null as string | null],
      business: [null as string | null],
      antiquity: [null as string | null],
      position: [null as string | null],
      whichPosition: [null as string | null],
      chevyPlan: [null as string, Validators.required],
      contract: [null as string | null],
      whichContract: [null as string | null],
      address2: this.fb.group({
        street: [null as string | null, Validators.required],
        streetNumber: [null as string | null, [Validators.required, Validators.pattern(this.pattern)]],
        houseNumber: [null as string | null, [Validators.required, Validators.pattern(this.pattern)]],
        oficeNumber: [null as string | null, Validators.required],
        apartment: [null as string | null],
        apartmentNumber: [null as string | null, Validators.pattern(this.pattern)],
        neighborhood: [null as string | null],
        neighborhoodField: [null as string | null]
      }),
      department2: [null as string | null, Validators.required],
      city2: [null as string | null],
      location2: [null as string | null],
      phone2: [null as string | null, {
        validators: [Validators.required, Validators.minLength(10)],
        updateOn: 'blur'
      }],
      cellular2: [null as string | null],
      activities2: [null as string | null],
      composition: [null as string | null],
      sectorActivity: [null as string | null],
      chamberOfCommerce: ['Si'],
      employees: [null as string | null],
      participation: [null as string | null],
      monthlyIncome: [null as string | null, Validators.required],
      otherIncome: [null as string | number | null],
      descriptionOtherIncome: [null as string | null],
      totalIncome: [null as string | number | null],
      totalExpenses: [null as string | null, Validators.required],
      totalAssets: [null as string | number | null, Validators.required],
      assetsDetail: [null as string | null],
      totalPassive: [null as string | null],
      reference3: ['1', Validators.required],
      idReference3: [0],
      name3: [null as string | null, Validators.required],
      relation3: [null as string | null, Validators.required],
      address3: this.fb.group({
        street: [null as string | null, Validators.required],
        streetNumber: [null as string | null, [Validators.required, Validators.pattern(this.pattern)]],
        houseNumber: [null as string | null, [Validators.required, Validators.pattern(this.pattern)]],
        oficeNumber: [null as string | null, Validators.required],
        apartment: [null as string | null],
        apartmentNumber: [null as string | null, Validators.pattern(this.pattern)],
        neighborhood: [null as string | null],
        neighborhoodField: [null as string | null]
      }),
      department3: [null as string | null, Validators.required],
      city3: [null as string | null,Validators.required],
      phone3: [null as string | null],
      cellular3: [null as string | null, Validators.required, null, {updateOn: 'blur'}],
      reference31: ['3', Validators.required],
      idReference31: [0],
      name31: [null as string | null, Validators.required],
      relation31: [null as string | null, Validators.required],
      address31: this.fb.group({
        street: [null as string | null, Validators.required],
        streetNumber: [null as string | null, [Validators.required, Validators.pattern(this.pattern)]],
        houseNumber: [null as string | null, [Validators.required, Validators.pattern(this.pattern)]],
        oficeNumber: [null as string | null, Validators.required],
        apartment: [null as string | null],
        apartmentNumber: [null as string | null, Validators.pattern(this.pattern)],
        neighborhood: [null as string | null],
        neighborhoodField: [null as string | null]
      }),
      department31: [null as string | null, Validators.required],
      city31: [null as string | null, Validators.required],
      phone31: [null as string | null],
      cellular31: [null as string | null, Validators.required, null, {updateOn: 'blur'}],
      reference32: [null as string | null],
      idReference32: [0],
      name32: [null as string | null],
      relation32: [null as string | null],
      address32: this.fb.group({
        street: [null as string | null],
        streetNumber: [null as string | null, [ Validators.pattern(this.pattern)]],
        houseNumber: [null as string | null, [ Validators.pattern(this.pattern)]],
        oficeNumber: [null as string | null],
        apartment: [null as string | null],
        apartmentNumber: [null as string | null, Validators.pattern(this.pattern)],
        neighborhood: [null as string | null],
        neighborhoodField: [null as string | null]
      }),
      department32: [null as string | null],
      city32: [null as string | null],
      phone32: [null as string | null],
      cellular32: [null as string | null, {updateOn: 'blur'}],
      automaticDebit: [null as boolean | null, Validators.required],
      hasSecondHolder: [false],
      sameHolder: [null as string | null],
      name4: [null as string | null],
      lastName4: [null as string | null],
      sureName4: [null as string | null],
      typeOfIdentity4: ['CC'],
      documentNumber4: [null as string | null],
      expeditionDate4: [null as NgbDateStruct | null],
      expeditionDepartment4: [null as string | null],
      expeditionCity4: [null as string | null],
      sex4: [null as string],
      address4: this.fb.group({
        street: [null as string | null],
        streetNumber: [null as string | null, [ Validators.pattern(this.pattern)]],
        houseNumber: [null as string | null, [ Validators.pattern(this.pattern)]],
        oficeNumber: [null as string | null],
        apartment: [null as string | null],
        apartmentNumber: [null as string | null, Validators.pattern(this.pattern)],
        neighborhood: [null as string | null],
        neighborhoodField: [null as string | null]
      }),
      phone4: [null as string | null],
      cellular4: [null as string | null, {updateOn: 'blur'}],
        email4: [null as string | null, [Validators.email]],

      bank: [null as string | null],
      accountNumber: ['0'],
      accountType: [null as string | null],
      department4: [null as string | null],
      city4: [null as string | null],
      location4: [null as string | null],
      debitFrom: [null as string | null],
      peps1: [null as string, Validators.required],
      pepsDesc1: [null as string | null],
      peps2: [null as string, Validators.required],
      pepsDesc2: [null as string | null],
      peps3: [null as string, Validators.required],
      pepsDesc3: [null as string | null],
      peps4: [null as string, Validators.required],
      pepsDesc4: [null as string | null],
      sourceOfIncome: [null as string, Validators.required],
      name5: [null as string | null],
      documentNumber5: [null as string | null],
      inName: ['NP'],
      thirdName: [null as string | null],
      thirdDocumentNumber: [null as string | null]
    }, { validators: equalFields('email', 'emailAlt') });

    this.department.valueChanges.subscribe(x => {
      this.city.reset();
    });
    this.city.valueChanges.subscribe(() => this.location.reset());
    this.department1.valueChanges.subscribe(() => this.city1.reset());
    this.city1.valueChanges.subscribe(() => this.location1.reset());
    this.department2.valueChanges.subscribe(() => this.city2.reset());
    this.city2.valueChanges.subscribe(() => this.location2.reset());
    this.department3.valueChanges.subscribe(() => this.city3.reset());
    this.department31.valueChanges.subscribe(() => this.city31.reset());
    this.department32.valueChanges.subscribe(() => this.city32.reset());
    this.department4.valueChanges.subscribe(() => this.city4.reset());
    this.city4.valueChanges.subscribe(() => this.location4.reset());

    this.civilStatus.valueChanges.subscribe(x => {
      if (x === 'C' || x === 'U') {
        this.requiredField(this.name1);
        this.requiredField(this.lastName1);
        this.requiredField(this.documentNumber1);
        this.address1.get('street').addValidators(Validators.required);
        this.address1.get('street').updateValueAndValidity();
        this.address1.get('streetNumber').addValidators([Validators.required, Validators.pattern(this.pattern)]);
        this.address1.get('streetNumber').updateValueAndValidity();
        this.address1.get('houseNumber').addValidators([Validators.required, Validators.pattern(this.pattern)]);
        this.address1.get('houseNumber').updateValueAndValidity();
        this.address1.get('oficeNumber').addValidators(Validators.required);
        this.address1.get('oficeNumber').updateValueAndValidity();
        this.address1.get('apartmentNumber').addValidators(Validators.pattern(this.pattern));
        this.address1.get('apartmentNumber').updateValueAndValidity();
        this.requiredField(this.department1);
        this.requiredField(this.phone1);
        this.requiredField(this.cellular1);
        this.requiredField(this.activities1);
        this.requiredField(this.dateOfBirth1);
        this.requiredField(this.sex1);
        this.requiredField(this.chevyPlan1);
        this.requiredField(this.city1);
      } else {
        this.resetField(this.name1);
        this.resetField(this.lastName1);
        this.resetField(this.surname1);
        this.resetField(this.documentNumber1);
        this.address1.get('street').clearValidators();
        this.address1.get('street').updateValueAndValidity();
        this.address1.get('streetNumber').clearValidators();
        this.address1.get('streetNumber').updateValueAndValidity();
        this.address1.get('houseNumber').clearValidators();
        this.address1.get('houseNumber').updateValueAndValidity();
        this.address1.get('oficeNumber').clearValidators();
        this.address1.get('oficeNumber').updateValueAndValidity();
        this.address1.get('apartmentNumber').clearValidators();
        this.address1.get('apartmentNumber').updateValueAndValidity();
        this.resetField(this.department1);
        this.resetField(this.phone1);
        this.resetField(this.cellular1);
        this.resetField(this.activities1);
        this.resetField(this.dateOfBirth1);
        this.resetField(this.sex1);
        this.resetField(this.chevyPlan1);
        this.resetField(this.city1);
      }
    });

    this.academicLevel.valueChanges.subscribe(x => {
      if(Number(x) > 2 && Number(x) < 8) {
        this.requiredField(this.profession);
        this.resetField(this.otherProfession);
      }
      else if(Number(x) === 8) {
        this.resetField(this.profession);
        this.requiredField(this.otherProfession);
      }
      else {
        this.resetField(this.profession);
        this.resetField(this.otherProfession);
      }
    });

    this.country.valueChanges.subscribe(x => {
      if(x === 'Colombia') {
        this.department.addValidators(Validators.required);
        this.department.updateValueAndValidity();
        if(this.adjudged)
          this.department.setValue(this.adjudged.ubication?.departmentId);
        this.city.updateValueAndValidity();
        this.cityOtherCountries.clearValidators();
        this.cityOtherCountries.updateValueAndValidity();
      }
      else {
        this.department.clearValidators();
        this.department.updateValueAndValidity();
        this.department.setValue(null as string);
        this.city.clearValidators();
        this.city.updateValueAndValidity();
        this.cityOtherCountries.addValidators(Validators.required);
        this.cityOtherCountries.updateValueAndValidity();
      }
    });

    this.job.valueChanges.subscribe(x => {
      if(!this.loadFromStogare){
        if (x === '7') {
          this.requiredField(this.whichJob);
          this.resetField(this.business);
          this.resetField(this.contract);
          this.resetField(this.activities2);
          this.resetField(this.composition);
          this.resetField(this.sectorActivity);
          this.resetField(this.chamberOfCommerce);
          this.resetField(this.employees);
          this.resetField(this.participation);
          this.resetField(this.otherIncome);
        }
        else if (x === '5') {
          this.resetField(this.whichJob);
          this.resetField(this.contract);
        }
        else if (x === '3') {
          this.reference32.setValue('4');
          this.requiredField(this.name32);
          this.requiredField(this.relation32);
          this.resetField(this.business);
          this.resetField(this.whichJob);
          this.resetField(this.contract);
        }
        else if (x === '2') {
          this.reference32.setValue('4');
          this.requiredField(this.activities2);
          this.requiredField(this.composition);
          this.requiredField(this.sectorActivity);
          this.requiredField(this.chamberOfCommerce);
          this.requiredField(this.employees);
          this.requiredField(this.participation);
          this.resetField(this.business);
          this.resetField(this.whichJob);
          this.resetField(this.contract);
        }
        else if (x === '1' || x === '6') {
          this.requiredField(this.business);
          this.requiredField(this.contract);
          this.resetField(this.whichJob);
          this.resetField(this.activities2);
          this.resetField(this.composition);
          this.resetField(this.sectorActivity);
          this.resetField(this.chamberOfCommerce);
          this.resetField(this.employees);
          this.resetField(this.participation);
          this.resetField(this.otherIncome);
        } else {
          this.resetField(this.business);
          this.resetField(this.whichJob);
          this.resetField(this.contract);
          this.resetField(this.activities2);
          this.resetField(this.composition);
          this.resetField(this.sectorActivity);
          this.resetField(this.chamberOfCommerce);
          this.resetField(this.employees);
          this.resetField(this.participation);
          this.resetField(this.otherIncome);
        }

        if (x === '2' || x === '3') {
          this.reference32.setValue(x === '2' ? '2' : '4');
          this.requiredField(this.name32);
          this.requiredField(this.relation32);
          this.address32.get('street').addValidators(Validators.required);
          this.address32.get('street').updateValueAndValidity();
          this.address32.get('streetNumber').addValidators([Validators.required, Validators.pattern(this.pattern)]);
          this.address32.get('streetNumber').updateValueAndValidity();
          this.address32.get('houseNumber').addValidators([Validators.required, Validators.pattern(this.pattern)]);
          this.address32.get('houseNumber').updateValueAndValidity();
          this.address32.get('oficeNumber').addValidators(Validators.required);
          this.address32.get('oficeNumber').updateValueAndValidity();
          this.address32.get('apartmentNumber').addValidators(Validators.pattern(this.pattern));
          this.address32.get('apartmentNumber').updateValueAndValidity();
          this.requiredField(this.department32);
          this.requiredField(this.city32);
          this.requiredField(this.cellular32);
        } else {
          this.resetField(this.reference32);
          this.resetField(this.name32);
          this.resetField(this.relation32);
          this.address32.get('street').clearValidators();
          this.address32.get('street').updateValueAndValidity();
          this.address32.get('streetNumber').clearValidators();
          this.address32.get('streetNumber').updateValueAndValidity();
          this.address32.get('houseNumber').clearValidators();
          this.address32.get('houseNumber').updateValueAndValidity();
          this.address32.get('oficeNumber').clearValidators();
          this.address32.get('oficeNumber').updateValueAndValidity();
          this.address32.get('apartmentNumber').clearValidators();
          this.address32.get('apartmentNumber').updateValueAndValidity();
          this.resetField(this.department32);
          this.resetField(this.city32);
          this.resetField(this.cellular32);
        }

        this.ciiu.setValue(null);
        this.whichJob.setValue(null);
        this.business.setValue(null);
        this.antiquity.setValue(null);
        this.position.setValue(null);
        this.whichPosition.setValue(null);
        this.contract.setValue(null);
        this.whichContract.setValue(null);
        this.chevyPlan.setValue(null);
        this.activities2.setValue(null);
        this.composition.setValue(null);
        this.sectorActivity.setValue(null);
        this.chamberOfCommerce.setValue(null);
        this.employees.setValue(null);
        this.participation.setValue(null);
        this.otherIncome.setValue(null);
        this.department2.setValue(null);
        this.city2.setValue(null);
        this.location2.setValue(null);
        this.phone2.setValue(null);
        this.cellular2.setValue(null);
        this.monthlyIncome.setValue(null);
        this.otherIncome.setValue(null);
        this.descriptionOtherIncome.setValue(null);
        this.totalIncome.setValue(null);
        this.totalAssets.setValue(null);
        this.totalExpenses.setValue(null);
        this.totalAssets.setValue(null);
        this.assetsDetail.setValue(null);
        this.totalPassive.setValue(null);
        this.address2.get('street').setValue(null);
        this.address2.get('streetNumber').setValue(null);
        this.address2.get('houseNumber').setValue(null);
        this.address2.get('oficeNumber').setValue(null);
        this.address2.get('apartment').setValue(null);
        this.address2.get('apartmentNumber').setValue(null);
        this.address2.get('neighborhood').setValue(null);
        this.address2.get('neighborhoodField').setValue(null);
      }
    });

    this.business.valueChanges.subscribe(x => {
      if (x !== null && x !== '') {
        this.requiredField(this.antiquity);
        this.requiredField(this.position);
      } else {
        this.resetField(this.antiquity);
        this.resetField(this.position);
      }
    });

    this.position.valueChanges.subscribe(x => {
      if (x === '32') {
        this.requiredField(this.whichPosition);
      } else {
        this.resetField(this.whichPosition);
      }
    });

    this.contract.valueChanges.subscribe(x => x === '4' ? this.requiredField(this.whichContract) : this.resetField(this.whichContract));

    this.otherIncome.valueChanges.subscribe(x => x === null || x === '' || x == 0 ? this.resetField(this.descriptionOtherIncome) : this.requiredField(this.descriptionOtherIncome));

    this.totalAssets.valueChanges.subscribe(x => x === null || x === '' || x == 0 ? this.resetField(this.assetsDetail) : this.requiredField(this.assetsDetail));

    this.automaticDebit.valueChanges.subscribe(x => {
      x ? this.requiredField(this.bank) : this.resetField(this.bank);
      x ? this.requiredField(this.accountNumber) : this.resetField(this.accountNumber);
      x ? this.requiredField(this.accountType) : this.resetField(this.accountType);
      x ? this.requiredField(this.department4) : this.resetField(this.department4);
      x ? this.requiredField(this.city4) : this.resetField(this.city4);
      x ? this.resetField(this.debitFrom) : this.resetField(this.debitFrom);
      x ? this.requiredField(this.sameHolder) : this.resetField(this.sameHolder);
      if (!x) { this.hasSecondHolder.setValue(false); }
    });

    this.hasSecondHolder.valueChanges.subscribe(x => {
      x ? this.requiredField(this.name4) : this.resetField(this.name4);
      x ? this.requiredField(this.lastName4) : this.resetField(this.lastName4);
      x ? this.requiredField(this.sureName4) : this.resetField(this.sureName4);
      x ? this.requiredField(this.documentNumber4) : this.resetField(this.documentNumber4);
      x ? this.requiredField(this.expeditionDate4) : this.resetField(this.expeditionDate4);
      x ? this.requiredField(this.expeditionDepartment4) : this.resetField(this.expeditionDepartment4);
      x ? this.requiredField(this.expeditionCity4) : this.resetField(this.expeditionCity4);
      x ? this.requiredField(this.address4) : this.resetField(this.address4);
      x ? this.requiredField(this.phone4) : this.resetField(this.phone4);
      x ? this.requiredField(this.cellular4) : this.resetField(this.cellular4);
      x ? this.requiredField(this.email4, true) : this.resetField(this.email4);
      x ? this.requiredField(this.sex4) : this.resetField(this.sex4);
    });

    this.name.valueChanges.subscribe(() => {
      this.updateAuthorization();
    });

    this.lastName.valueChanges.subscribe(() => {
      this.updateAuthorization();
    })

    this.surname.valueChanges.subscribe(() => {
      this.updateAuthorization();
    })

    this.documentNumber.valueChanges.subscribe(x => {
      this.updateAuthorization();
    });

    this.inName.valueChanges.subscribe(() => {
      this.updateAuthorization();
    });

    this.expeditionDepartment.valueChanges.subscribe(x => {
      const dep = this.d;
    });
  }

  ngOnInit() {
    this.addLogsNav();

    this.spinnerService.show();
    setTimeout(() => this.data(), 500);

  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }

data = () => {
    this.adjudgedInfo = this.actPetition.adjudgedInfo;
    this.transfer.setValue('No');
    // Codeudor según su pertenencia a ESTA solicitud, no por el rol global (ver findPetitionCoDebtor).
    const codebtor = this.isSecondHolder ? null : findPetitionCoDebtor(this.actPetition, this.userServices.user.id);
    this.role.setValue(codebtor ? 'C' : 'D');
    this.debtor.setValue(!this.isSecondHolder ? 'D1' : 'D2');
    this.contractNumber.setValue(this.adjudgedInfo.contractNumber);
    this.quotaNumber.setValue(this.adjudgedInfo.quotaNumber);

    let userId = this.actPetition.userId;
    if(this.isSecondHolder)
      userId = this.actPetition.secondHolder?.userId
    else if(codebtor)
      userId = this.userServices.user.id;
    this.formIdentifier = `paymentCapacity_${this.actPetition.id}_${userId}`;

    this.personaService.getPeopleByUser(userId).subscribe(data => {
      this.adjudged = data;
      this.apellidos = this.adjudged.lastName.split(' ');
      this.apellido1 = this.apellidos[0];
      this.apellido2 = this.apellidos.filter(e => {
        if(e !== null && e !== this.apellido1){
          return e;
        }
      });
      this.name.setValue(data.name);
      this.lastName.setValue(this.apellido1);
      this.surname.setValue(this.apellido2[0]);
      this.typeOfIdentity.setValue(data.typeOfIdentity);
      this.documentNumber.setValue(data.documentNumber);

      if(this.userLogged.role != 'Codeudor') {
        this.dateOfBirth.setValue(setDateStructure(data.dateOfBirth));
      }

      this.expeditionDate.setValue(data.expDate.toString() === "0001-01-01T00:00:00" ? null : setDateStructure(data.expDate));

      this.valueService.getAllUbications().subscribe(ubi => {
        this.d = ubi;
        setTimeout(() => {
          if(!this.department.value) this.department.setValue(data.ubication?.departmentId);
          this.c1 = this.d.find(x => x.valueId === this.department.value)?.cities;
          this.location.value;
          this.l1 = this.c1?.find(x => x.valueId === this.city.value)?.localities;
          this.c2 = this.d?.find(x => x.valueId === this.department1.value)?.cities;
          this.l2 = this.c2?.find(x => x.valueId === this.city1.value)?.localities;
          this.c3 = this.d?.find(x => x.valueId === this.department2.value)?.cities;
          this.l3 = this.c3?.find(x => x.valueId === this.city2.value)?.localities;
          this.c4 = this.d?.find(x => x.valueId === this.department3.value)?.cities;
          this.c40 = this.d?.find(x => x.valueId === this.expeditionDepartment4.value)?.cities;
          this.c41 = this.d?.find(x => x.valueId === this.department31.value)?.cities;
          this.c42 = this.d?.find(x => x.valueId === this.department32.value)?.cities;
          this.c5 = this.d?.find(x => x.valueId === this.department4.value)?.cities;
          this.l5 = this.c5?.find(x => x.valueId === this.city4.value)?.localities;
          this.c10 = this.d?.find(x => x.valueId === this.expeditionDepartment.value)?.cities;
        }, 550);

        this.paymentCapacityService.getPaymentCapacityById(this.actPetition.id).subscribe(res => {
          if(res)
             this.setPaymentFromService(res);
        });
      }, error => this.handleError(error));

      setTimeout(async () => {
        this.city.setValue(data?.ubication?.cityId);
        this.location.setValue(data?.ubication?.localityId);
        this.l1 = this.c1?.find(x => x.valueId === data?.ubication?.cityId)?.localities;
        this.loadFromStogare=true;
        await loadForm(this.forma, this.formIdentifier);
        const storageValues=  JSON.parse(localStorage.getItem(this.formIdentifier));
        if(storageValues){
          this.direcciones.push(this.addressConstruction("address1",storageValues.address1));
          this.direcciones.push(this.addressConstruction("address2",storageValues.address2));
          this.direcciones.push(this.addressConstruction("address3",storageValues.address3));
          this.direcciones.push(this.addressConstruction("address31",storageValues.address31));
          this.direcciones.push(this.addressConstruction("address32",storageValues.address32));
        }
        this.loadFromStogare=false;
        this.startDate.setValue(this.hoy);
      }, 500);
      this.phone.setValue(data.phone);
      this.cellular.setValue(data.cellPhone);
      this.email.setValue(data.email);
      this.name5.setValue(this.surname.value == null ? this.name.value + " " + this.lastName.value : this.name.value + " " + this.lastName.value + " " + this.surname.value);
      this.documentNumber5.setValue(this.documentNumber.value);


      this.spinnerService.hide();
      Swal.fire(swalInfo("Nos complace saber que continuará con el proceso", "Le agradecemos completar la información del formulario", 5000)).then(() => this.forma.enable({emitEvent: false}));
    }, error => this.handleError(error));
  }

  asyncEmailValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const emailRegex = new RegExp(EMAIL_PATTERN);
      return of(control.value).pipe(
        delay(1000),
        map(value => {
          if (!emailRegex.test(value)) {
            return { invalidEmail: true };
          }
          return null;
        }),
        catchError(() => of(null))
      );
    };
  }

  loadData = (data: PaymentCapacity) => {
    this.modal ? this.forma.disable() : this.forma.enable();
    this.hoy = this.modal ? null : this.hoy;
    this.startDate.setValue(this.modal ? setDateStructure(data.date) : this.hoy);
    this.transfer.setValue(data.transfer ? 'Si' : 'No');
    this.role.setValue(data.role.valueId);
    this.debtor.setValue(data.debtor.valueId);
    this.contractNumber.setValue(data.contractNumber);
    this.quotaNumber.setValue(data.quotaNumber);

    this.name.setValue(data.applicant.name);
    this.lastName.setValue(data.applicant.lastName);
    this.surname.setValue(data.applicant.surname);
    this.typeOfIdentity.setValue(data.applicant.typeOfIdentity);
    this.documentNumber.setValue(data.applicant.documentNumber);
    this.expeditionDate.setValue(setDateStructure(data.applicant.expDate));
    this.valueService.getUbication(data.applicant.expCity).then(ubic => {
      this.c10 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.expeditionDepartment.setValue(ubic.departmentId);
      this.expeditionCity.setValue(ubic.cityId);
    }).catch(error => this.handleError(error));
    this.sex.setValue(data.applicant.sex.valueId);
    this.dateOfBirth.setValue(setDateStructure(data.applicant.dateOfBirth));
    this.nationality.setValue(data.applicant.nacionality.valueId);
    this.civilStatus.setValue(data.applicant.civilStatus.valueId);
    this.academicLevel.setValue(data.applicant.academicLevel.valueId);
    this.profession.setValue(data.applicant.profession.valueId);
    this.minorLoad.setValue(data.applicant.dependentsOver18);
    this.higherLoad.setValue(data.applicant.dependentsUnder18);
    this.housing.setValue(data.applicant.housingType.valueId);
    this.rent.setValue(data.applicant.declareRent ? 'Si' : 'No');
    this.address.setValue(data.applicant.address);
    this.valueService.getUbication(data.applicant.city).then(ubic => {
      this.c1 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.l1 = this.c1.find(x => x.valueId === ubic.cityId).localities;
      this.department.setValue(ubic.departmentId);
      this.city.setValue(ubic.cityId);
      this.location.setValue(ubic.localityId);
    }).catch(error => this.handleError(error));
    this.stratum.setValue(data.applicant.stratumSE.valueId);
    this.yearsResidence.setValue(data.applicant.yearsInResidence.toString());
    this.phone.setValue(data.applicant.phone);
    this.cellular.setValue(data.applicant.cellPhone);
    this.email.setValue(data.applicant.email);

    this.name1.setValue(data.spouse.name);
    this.lastName1.setValue(data.spouse.lastName);
    this.surname1.setValue(data.spouse.surname);
    this.typeOfIdentity1.setValue(data.spouse.typeOfIdentity);
    this.documentNumber1.setValue(data.spouse.documentNumber);
    this.dateOfBirth1.setValue(setDateStructure(data.spouse.dateOfBirth));
    this.address1.setValue(data.spouse.address);
    this.valueService.getUbication(data.spouse.city).then(ubic => {
      this.c2 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.l2 = this.c2.find(x => x.valueId === ubic.cityId).localities;
      this.department1.setValue(ubic.departmentId);
      this.city1.setValue(ubic.cityId);
      this.location1.setValue(ubic.localityId);
    }).catch(error => this.handleError(error));
    this.phone1.setValue(data.spouse.phone);
    this.cellular1.setValue(data.spouse.cellPhone);
    this.activities1.setValue(data.spouse.spounseEconomicActivity);

    this.ciiu.setValue(data.ecoActivApplicant.ciiuCode.valueId);
    this.job.setValue(data.ecoActivApplicant.job.valueId);
    this.whichJob.setValue(data.ecoActivApplicant.whichJob);
    this.business.setValue(data.ecoActivApplicant.companyName);
    this.antiquity.setValue(data.ecoActivApplicant.antiquity.valueId);
    this.position.setValue(data.ecoActivApplicant.position.valueId);
    this.chevyPlan.setValue(data.ecoActivApplicant.relationship ? 'Si' : 'No');
    this.contract.setValue(data.ecoActivApplicant.contract.valueId);
    this.whichContract.setValue(data.ecoActivApplicant.whichContract);
    this.address2.setValue(data.ecoActivApplicant.address);
    this.valueService.getUbication(data.ecoActivApplicant.city).then(ubic => {
      this.c3 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.l3 = this.c3.find(x => x.valueId === ubic.cityId).localities;
      this.department2.setValue(ubic.departmentId);
      this.city2.setValue(ubic.cityId);
      this.location2.setValue(ubic.localityId);
    }).catch(error => this.handleError(error));
    this.phone2.setValue(data.ecoActivApplicant.phones);
    this.cellular2.setValue(data.ecoActivApplicant.cellPhones);
    this.activities2.setValue(data.ecoActivApplicant.ecoActivIndependent);
    this.composition.setValue(data.ecoActivApplicant.composition?.valueId);
    this.sectorActivity.setValue(data.ecoActivApplicant.sector?.valueId);
    this.chamberOfCommerce.setValue(data.ecoActivApplicant.chamberOfCommerce ? 'Si' : 'No');
    this.employees.setValue(data.ecoActivApplicant.numEmployees.toString());
    this.participation.setValue(data.ecoActivApplicant?.numPartCompany ? data.ecoActivApplicant.numPartCompany.toString() : null);

    this.monthlyIncome.setValue(data.financialInfo.monthlyIncome ? data.financialInfo.monthlyIncome.toString() : null);
    this.otherIncome.setValue(data.financialInfo.otherMonthlyIncome ? data.financialInfo.otherMonthlyIncome.toString() : null);
    this.descriptionOtherIncome.setValue(data.financialInfo.descripOtherMI);
    this.sumTotalIncome();
    this.totalExpenses.setValue(data.financialInfo.totalExpenses ? data.financialInfo.totalExpenses.toString() : null);
    this.totalAssets.setValue(data.financialInfo.totalAssets ? data.financialInfo.totalAssets.toString() : null);
    this.assetsDetail.setValue(data.financialInfo.assetsDetail ? JSON.parse(data.financialInfo.assetsDetail) : null);
    this.totalPassive.setValue(data.financialInfo.totalPassive ? data.financialInfo.totalPassive.toString() : null);

    const fam = data.references.find(x => x.refType.valueId === '1');
    this.reference3.setValue(fam.refType.valueId);
    this.name3.setValue(fam.name);
    this.relation3.setValue(fam.relationship.valueId);
    this.address3.setValue(fam.address);
    this.valueService.getUbication(fam.city).then(ubic => {
      this.c4 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.department3.setValue(ubic.departmentId);
      this.city3.setValue(ubic.cityId);
    }).catch(error => this.handleError(error));
    this.phone3.setValue(fam.phone);

    const per = data.references.find(x => x.refType.valueId === '3');
    this.reference31.setValue(per.refType.valueId);
    this.name31.setValue(per.name);
    this.relation31.setValue(per.relationship.valueId);
    this.address31.setValue(per.address);
    this.valueService.getUbication(per.city).then(ubic => {
      this.c41 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.department31.setValue(ubic.departmentId);
      this.city31.setValue(ubic.cityId);
    }).catch(error => this.handleError(error));
    this.phone31.setValue(per.phone);

    if (data.ecoActivApplicant.job.valueId === '2' || data.ecoActivApplicant.job.valueId === '3') {
      const ref = data.references.find(x => x.refType.valueId !== '1' && x.refType.valueId !== '3');
      if (ref) {
        this.reference32.setValue(ref.refType.valueId);
        this.name32.setValue(ref.name);
        this.relation32.setValue(ref.relationship.valueId);
        this.address32.setValue(ref.address);
        this.valueService.getUbication(ref.city).then(ubic => {
          this.c42 = this.d.find(x => x.valueId === ubic.departmentId).cities;
          this.department32.setValue(ubic.departmentId);
          this.city32.setValue(ubic.cityId);
        }).catch(error => this.handleError(error));
        this.phone32.setValue(ref.phone);
      }
    }

    this.automaticDebit.setValue(data.account?.financialEntity ? true : false);
    this.hasSecondHolder.setValue(data.account?.secondHolder ? true : false);
    this.name4.setValue(data.account.secondHolder.name);
    this.lastName4.setValue(data.account.secondHolder.lastName);
    this.sureName4.setValue(data.account.secondHolder.sureName);
    this.typeOfIdentity4.setValue(data.account.secondHolder.typeOfIdentity);
    this.documentNumber4.setValue(data.account.secondHolder.documentNumber);
    this.expeditionDate4.setValue(setDateStructure(data.account.secondHolder.expDate));
    this.valueService.getUbication(data.account.secondHolder.expCity).then(ubic => {
      this.c40 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.expeditionDepartment4.setValue(ubic.departmentId);
      this.expeditionCity4.setValue(ubic.cityId);
    }).catch(error => this.handleError(error));
    this.sex4.setValue(data.account.secondHolder.sex.valueId);
    this.address4.setValue(data.account.secondHolder.address);
    this.phone4.setValue(data.account.secondHolder.phone);
    this.cellular4.setValue(data.account.secondHolder.cellPhone);
    this.email4.setValue(data.account.secondHolder.email);
    this.bank.setValue(data.account.financialEntity?.valueId);
    this.accountNumber.setValue(data.account.accountNumber);
    this.accountType.setValue(data.account.accountType?.valueId);
    this.valueService.getUbication(data.account.city).then(ubic => {
      this.c5 = this.d.find(x => x.valueId === ubic.departmentId).cities;
      this.l5 = this.c5.find(x => x.valueId === ubic.cityId).localities;
      this.department4.setValue(ubic.departmentId);
      this.city4.setValue(ubic.cityId);
      this.location4.setValue(ubic.localityId);
    }).catch(error => this.handleError(error));
    this.debitFrom.setValue(data.account.debitFrom.valueId);

    this.id.setValue(data.peps.id);
    this.peps1.setValue(data.peps.pepsResponse1 ? 'Si' : 'No');
    this.pepsDesc1.setValue(data.peps.pepsDescription1);
    this.peps2.setValue(data.peps.pepsResponse2 === true ? 'Si' : 'No');
    this.pepsDesc2.setValue(data.peps.pepsDescription2);
    this.peps3.setValue(data.peps.pepsResponse3 === true ? 'Si' : 'No');
    this.pepsDesc3.setValue(data.peps.pepsDescription3);
    this.peps4.setValue(data.peps.pepsResponse4 === true ? 'Si' : 'No');
    this.pepsDesc4.setValue(data.peps.pepsDescription4);
    this.sourceOfIncome.setValue(data.peps.sourceOfIncome);

    this.name5.setValue(data.authorizeDeclare.name);
    this.documentNumber5.setValue(data.authorizeDeclare.documentNumber);
    this.inName.setValue(data.authorizeDeclare.inName);
    this.thirdName.setValue(data.authorizeDeclare.thirdName);
    this.thirdDocumentNumber.setValue(data.authorizeDeclare.thirdDocumentNumber);
  }

  addressConstructed(direccion: Direction){
    this.direcciones.push(direccion);

  }

  getValues = () => {
    this.loadValues = true;
    const types = ['rol', 'deudor', 'tipoident', 'sexo', 'estadocivil', 'nivelacademico', 'tipovivienda', 'estratose', 'actividades', 'empleo', 'tipocontrato', 'composicion', 'sectorae', 'activos', 'tiporelacion', 'tipocuenta', 'banco', 'nacionalidad', 'relacion', 'profesion', 'residencia', 'cargo', 'empleados', 'debitar', 'pais'];
    this.valueService.getValuesGroup(types).subscribe(data => {
      const buscar = (type: string) => this.values.filter(x => x.type === type);
      const ordenar = (values: Value[], orderName = true) => values.sort((a, b) => orderName ? a.name.localeCompare(b.name) : parseInt(a.valueId, 0) - parseInt(b.valueId, 0));
      const ordenar2 = (values: Value[]) => values.sort((a, b) =>  (a.id < b.id) ? 1 : -1);
      this.values = data;
      this.ci = ordenar(buscar('actividades'), false);
      this.tr = ordenar(buscar('rol'));
      this.tp = ordenar(buscar('deudor'));
      this.td = ordenar(buscar('tipoident'));
      this.s = ordenar(buscar('sexo'));
      this.ec = ordenar2(buscar('estadocivil'));
      this.na = ordenar(buscar('nivelacademico'), false);
      this.tv = ordenar(buscar('tipovivienda'));
      this.ese = ordenar(buscar('estratose'));
      this.act = ordenar(buscar('actividades'));
      this.emp = ordenar2(buscar('empleo'));
      this.tc = ordenar2(buscar('tipocontrato'));
      this.c = ordenar(buscar('composicion'));
      this.sa = ordenar2(buscar('sectorae'));
      this.a = ordenar(buscar('activos'));
      this.r = ordenar(buscar('tiporelacion'));
      this.tcs = ordenar(buscar('tipocuenta'));
      this.n = ordenar(buscar('nacionalidad'));
      this.p = ordenar(buscar('profesion'), false);
      this.ar = ordenar(buscar('residencia'), false);
      this.ca = ordenar(buscar('cargo'), false);
      this.e = ordenar(buscar('empleados'), false);
      this.pa = ordenar(buscar('relacion'), false);
      this.ef = ordenar(buscar('banco'));
      this.df = ordenar(buscar('debitar'), false);
      this.paises = ordenar(buscar('pais'), false);

    }, error => this.handleError(error));
    this.loadValues = false;
  }

  clearField = (field: AbstractControl) => {
    field.clearValidators();
    field.updateValueAndValidity();
  }

  requiredField = (field: AbstractControl, email = false) => {
    field.setValidators(email ? [Validators.required, Validators.pattern(EMAIL_PATTERN)] : Validators.required);
    field.updateValueAndValidity();
  }

  resetField = (field: AbstractControl) => {
    this.clearField(field);
    field.reset();
  }

  validateField = (field: AbstractControl) => {
    field.markAsTouched();
    field.updateValueAndValidity();
  }

  sumTotalIncome = () => this.totalIncome.setValue((getValueSum(this.monthlyIncome.value) + getValueSum(this.otherIncome.value)).toString());

  validarForm(formGroup: FormGroup | FormArray) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup || control instanceof FormArray) {
        this.validarForm(control);
      }
    });
  }

  registrar = () => {
    this.formSubmitted = true;
    if (!isValidForm(this.forma)) {
      Swal.fire(swalInfo('Faltan campos requeridos, verifique'));
      this.validarForm(this.forma);
      this.formSubmitted = false;
      return;
    }

    sessionStorage.setItem("capacidadPago", JSON.stringify(this.datosForm()));

    const logNav = (JSON.parse(sessionStorage.getItem('logNav')))
    logNav.visitedPage = location.href;
    sessionStorage.removeItem('logNav');
    sessionStorage.setItem("logNav", JSON.stringify(logNav));

    saveForm(this.forma, this.formIdentifier);
    Swal.fire(swalSuccess()).then(() => this.router.navigate([`otp`, 1]));
  }

  datosForm = (): PaymentCapacity => {
    if (this.paymentCapacity) {
    } else {
      this.paymentCapacity = {
        petitionId: this.actPetition.id,
        date: this.startDate.value ? setDate(this.startDate.value) : null,
        transfer: this.transfer.value ? (this.transfer.value === 'Si' ? true : false) : null,
        roleId: this.role.value,
        debtorId: this.debtor.value,
        contractNumber: this.contractNumber.value,
        quotaNumber: this.quotaNumber.value,
        applicant: {
          id: this.adjudged.id,
          name: this.name.getRawValue() ?? '',
          lastName: this.lastName.getRawValue() ?? '',
          surname: this.surname.getRawValue() ?? '',
          typeOfIdentity: this.typeOfIdentity.getRawValue() ?? 'CC',
          documentNumber: this.documentNumber.getRawValue() ? (Number(this.documentNumber.getRawValue())).toString() : '',
          expDate: this.expeditionDate.value ? setDate(this.expeditionDate.value) : null,
          expCity: this.expeditionCity.value,
          sexId: this.sex.value,
          dateOfBirth: this.dateOfBirth.value ? setDate(this.dateOfBirth.value) : null,
          nacionalityId: this.nationality.value,
          civilStatusId: this.civilStatus.value,
          academicLevelId: this.academicLevel.value,
          professionId: this.profession.value,
          otherProfession: this.otherProfession.value,
          dependentsOver18: this.minorLoad.value ? Number(this.minorLoad.value) : null,
          dependentsUnder18: this.higherLoad.value ? Number(this.higherLoad.value) : null,
          housingTypeId: this.housing.value,
          declareRent: this.rent.value ? (this.rent.value === 'Si' ? true : false) : null,
          address: this.address.value ? this.direcciones.filter(ad => ad.id === 'address').map(({direccion}) => direccion).at(-1) : null,
          userId: this.userLogged.id,
          city: this.location.value ? this.location.value : this.city.value ?? null,
          stratumSEId: this.stratum.value,
          yearsInResidence: this.yearsResidence.value ? parseInt(this.yearsResidence.value, 0) : null,
          phone: this.phone.value ? this.phone.value.toString() : null,
          cellPhone: this.cellular.value ? this.cellular.value.toString() : null,
          email: this.email.value,
          emailAlt: this.emailAlt.value,
          cityOtherCountries: this.cityOtherCountries.value,
          country: this.country.value
        },
        spouse: this.civilStatus.value === 'C' || this.civilStatus.value === 'U' ? {
          name: this.name1.value ?? '',
          lastName: this.lastName1.value ?? '',
          surname: this.surname1.value ?? '',
          typeOfIdentity: this.typeOfIdentity1.value ?? 'CC',
          documentNumber: this.documentNumber1.value ? (Number(this.documentNumber1.value)).toString() : '',
          dateOfBirth: this.dateOfBirth1.value ? setDate(this.dateOfBirth1.value) : null,
          sexId: this.sex1.value,
          relationship: this.chevyPlan1.value ? (this.chevyPlan1.value === 'Si' ? true : false) : null,
          address: this.address1.value ? this.direcciones.filter(ad => ad.id === 'address1').map(({direccion}) => direccion).at(-1) : null,
          city: this.location1.value ? this.location1.value : this.city1.value ?? null,
          phone: this.phone1.value ? this.phone1.value.toString() : null,
          cellPhone: this.cellular1.value?.toString(),
          spounseEconomicActivity: this.activities1.value
        } : null,
        ecoActivApplicant: {
          ciiuCodeId: this.ciiu.value,
          jobId: this.job.value,
          whichJob: this.whichJob.value,
          companyName: this.business.value,
          antiquityId: this.antiquity.value ? this.antiquity.value : null,
          positionId: this.position.value,
          whichPosition: this.whichPosition.value,
          relationship: this.chevyPlan.value ? (this.chevyPlan.value === 'Si' ? true : false) : null,
          contractId: this.contract.value,
          whichContract: this.whichContract.value,
          address: this.address2.value ? this.direcciones.filter(ad => ad.id === 'address2').map(({direccion}) => direccion).at(-1) : null,
          city: this.location2.value ? this.location2.value : this.city2.value ?? null,
          phones: this.phone2.value !='null'? this.phone2.value?.toString():0,
          cellPhones: this.cellular2.value ? this.cellular2.value.toString() : null,
          ecoActivIndependent: this.activities2.value,
          compositionId: this.composition.value,
          sectorId: this.sectorActivity.value,
          chamberOfCommerce: this.chamberOfCommerce.value ? (this.chamberOfCommerce.value === 'Si' ? true : false) : null,
          numEmployees: this.employees.value ? parseInt(this.employees.value, 0) : null,
          numPartCompany: this.participation.value ? parseFloat(this.participation.value) : 0
        },
        financialInfo: {
          monthlyIncome: this.monthlyIncome.value ? parseInt(this.monthlyIncome.value, 0) : null,
          otherMonthlyIncome: this.otherIncome.value ? getValueSum(this.otherIncome.value) : null,
          descripOtherMI: this.descriptionOtherIncome.value ?? null,
          totalIncome: this.totalIncome.value ? parseInt(String(this.totalIncome.value), 0) : null,
          totalExpenses: this.totalExpenses.value ? parseInt(this.totalExpenses.value, 0) : null,
          totalAssets: this.totalAssets.value ? parseInt(String(this.totalAssets.value), 0) : null,
          assetsDetail: this.assetsDetail.value ? JSON.stringify(this.assetsDetail.value) : null,
          totalPassive: this.totalPassive.value ? parseInt(this.totalPassive.value, 0) : null
        },
        references: [
          {
            id:this.idReference3.value,
            refTypeId: this.reference3.value,
            name: this.name3.value,
            relationshipId: this.relation3.value,
            address: this.address3.value ? this.direcciones.filter(ad => ad.id === 'address3').map(({direccion}) => direccion).at(-1) : null,
            city: this.city3.value,
            phone: this.phone3.value !=null && this.phone3.value !='' && this.phone3.value!='undefined' ? parseInt(String(this.phone3.value)) : 0,
            cellPhone: this.cellular3.value ? this.cellular3.value : 0
          },
          {
            refTypeId: this.reference31.value,
            id:this.idReference31.value,
            name: this.name31.value,
            relationshipId: this.relation31.value,
            address: this.address31.value ? this.direcciones.filter(ad => ad.id === 'address31').map(({direccion}) => direccion).at(-1) : null,
            city: this.city31.value,
            phone: this.phone31.value !=null && this.phone31.value !='' && this.phone31.value!='undefined' ? parseInt(String(this.phone31.value)) : 0,
            cellPhone: this.cellular31.value ? this.cellular31.value : 0
          },
          {
            refTypeId: this.reference32.value,
            id:this.idReference32.value,
            name: this.name32.value,
            relationshipId: this.relation32.value,
            address: this.address32.value ? this.direcciones.filter(ad => ad.id === 'address32').map(({direccion}) => direccion).at(-1) : null,
            city: this.city32.value,
            phone: this.phone32.value !=null && this.phone32.value !='' && this.phone32.value!='undefined' ?  parseInt(String(this.phone32.value)) : 0,
            cellPhone: this.cellular32.value ? this.cellular32.value == "undefined" ? 0 : this.cellular32.value : 0
          }
        ],
        account: this.automaticDebit.value ? {
          secondHolder: this.hasSecondHolder.value ? {
            name: this.name4.value ?? '',
            lastName: this.lastName4.value ?? '',
            sureName: this.sureName4.value ?? '',
            typeOfIdentity: this.typeOfIdentity4.value ?? 'CC',
            documentNumber: this.documentNumber4.value ? (Number(this.documentNumber4.value)).toString() : '',
            expDate: this.expeditionDate4.value ? setDate(this.expeditionDate4.value) : null,
            expCity: this.expeditionCity4.value,
            sexId: this.sex4.value,
            address: this.address4.value ? this.direcciones.filter(ad => ad.id === 'address4').map(({direccion}) => direccion).at(-1) : null,
            phone: this.phone4.value?.toString( ),
            cellPhone: this.cellular4.value?.toString(),
            email: this.email4.value,
          } : null,
          sameHolder: this.sameHolder.value ? (this.sameHolder.value  ? true : false) : null,
          financialEntityId: this.bank.value,
          accountNumber: this.accountNumber.value,
          accountTypeId: this.accountType.value,
          city: this.location4.value ? this.location4.value : this.city4.value,
          debitFromId: this.debitFrom.value
        } : null,
        peps: {
          pepsResponse1: this.peps1.value ? (this.peps1.value === 'Si' ? true : false) : null,
          pepsDescription1: this.pepsDesc1.value,
          pepsResponse2: this.peps2.value ? (this.peps2.value === 'Si' ? true : false) : null,
          pepsDescription2: this.pepsDesc2.value,
          pepsResponse3: this.peps3.value ? (this.peps3.value === 'Si' ? true : false) : null,
          pepsDescription3: this.pepsDesc3.value,
          pepsResponse4: this.peps4.value ? (this.peps4.value === 'Si' ? true : false) : null,
          pepsDescription4: this.pepsDesc4.value,
          sourceOfIncome: this.sourceOfIncome.value
        },
        authorizeDeclare: {
          name: this.name5.value ?? '',
          documentNumber: this.documentNumber5.value ? (Number(this.documentNumber5.value)).toString() : '',
          inName: this.inName.value,
          thirdName: this.thirdName.value ?? '',
          thirdDocumentNumber: this.thirdDocumentNumber.value ? (Number(this.thirdDocumentNumber.value)).toString() : ''
        }
      };
      if (this.job.value !== '2' && this.job.value !== '3') this.paymentCapacity.references.splice(2, 1);

    }
    return this.paymentCapacity;
  }

  handleError = (err) => {
    this.spinnerService.hide(); Swal.fire(swalError('Ha ocurrido un error', err.error?err.error.userMessage:err.userMessage));
   };

  updateAuthorization() {
    if(this.inName.value === 'NP') {
      this.documentNumber5.setValue(this.documentNumber.value);
      this.thirdDocumentNumber.setValue(null);
      this.name5.setValue(this.surname.value == null ? this.name.value + " " + this.lastName.value : this.name.value + " " + this.lastName.value + " " + this.surname.value);
      this.thirdName.setValue(null);
      this.resetThirdPerson = true;
      this.name5.clearValidators();
      this.name5.updateValueAndValidity();
      this.documentNumber5.clearValidators();
      this.documentNumber5.updateValueAndValidity();
    }
    else if(this.inName.value === 'RL' || this.inName.value === 'A') {
      this.thirdDocumentNumber.setValue(this.documentNumber.value);
      this.thirdName.setValue(this.name.value + " " + this.lastName.value + " " + this.surname.value);
      if(this.resetThirdPerson) {
        this.documentNumber5.setValue(null);
        this.name5.setValue(null);
        this.resetThirdPerson = false;
      }
      this.requiredField(this.name5);
      this.requiredField(this.documentNumber5);
    }
  }

  onSave() {
    Swal.fire(swalDesition('Guardar información', '¿Desea guardar la información diligenciada para reanudar este formulario en otro momento?')).then(res => {
      if (res.value) {
        this.spinnerService.show();
        saveForm(this.forma, this.formIdentifier);
        this.paymentCapacityService.postPartialPaymentCapacity(this.datosForm()).subscribe(async () => {
          this.spinnerService.hide();
          await Swal.fire(swalSuccess('Verificación exitosa')).then(() => {
            this.router.navigate([`proceso`]);
          });
        }, err => {
          this.handleError(err);
        });

      }
    });
  }


  onBack() {
    this.router.navigate([`proceso-capacidad-pago`, 1]);
  }
  async setPaymentFromService(paymentCapacity: PaymentCapacity) {

    if(paymentCapacity.applicant.expCity != null) {
      await this.valueService.getUbication(paymentCapacity.applicant.expCity).then(ubic => {
        this.c10 = this.d.find(x => x.valueId === ubic.departmentId).cities;
        this.expeditionDepartment.setValue(ubic.departmentId);
        this.expeditionCity.setValue(ubic.cityId);
      }).catch(error => this.handleError(error));
    }

    if(paymentCapacity.applicant.city != null) {
      await this.valueService.getUbication(paymentCapacity.applicant.city).then(ubic => {
        this.c1 = this.d.find(x => x.valueId === ubic.departmentId).cities;
        this.l1 = this.c1.find(x => x.valueId === ubic.cityId).localities;
        this.department.setValue(ubic.departmentId);
        this.city.setValue(ubic.cityId);
        this.location.setValue(ubic.localityId);
      }).catch(error => this.handleError(error));
    }

    if(paymentCapacity.spouse?.city != null) {
      await this.valueService.getUbication(paymentCapacity.spouse?.city).then(ubic => {
        this.c2 = this.d.find(x => x.valueId === ubic.departmentId).cities;
        this.l2 = this.c1.find(x => x.valueId === ubic.cityId).localities;
        this.department2.setValue(ubic.departmentId);
        this.city2.setValue(ubic.cityId);
        this.location2.setValue(ubic.localityId);
      }).catch(error => this.handleError(error));
    }

    if(paymentCapacity.ecoActivApplicant?.city != null) {
      await this.valueService.getUbication(paymentCapacity.ecoActivApplicant?.city).then(ubic => {
        this.c3 = this.d.find(x => x.valueId === ubic.departmentId).cities;
        this.department2.setValue(ubic.departmentId);
        this.city2.setValue(ubic.cityId);
        this.location2.setValue(ubic.localityId);
      }).catch(error => this.handleError(error));
    }

    if(paymentCapacity.references[0]?.city != null) {
      await this.valueService.getUbication(paymentCapacity.references[0]?.city).then(ubic => {
        this.c4 = this.d.find(x => x.valueId === ubic.departmentId).cities;
        this.department3.setValue(ubic.departmentId);
        this.city3.setValue(ubic.cityId);
      }).catch(error => this.handleError(error));
    }

    if(paymentCapacity.references[1]?.city != null) {
      await this.valueService.getUbication(paymentCapacity.references[1]?.city).then(ubic => {
        this.c41 = this.d.find(x => x.valueId === ubic.departmentId).cities;
        this.department31.setValue(ubic.departmentId);
        this.city31.setValue(ubic.cityId);
      }).catch(error => this.handleError(error));
    }


    if(paymentCapacity.references[2]?.city != null) {
      await this.valueService.getUbication(paymentCapacity.references[2]?.city).then(ubic => {
        this.c42 = this.d.find(x => x.valueId === ubic.departmentId).cities;
        this.department32.setValue(ubic.departmentId);
        this.city32.setValue(ubic.cityId);
      }).catch(error => this.handleError(error));
    }

    if(paymentCapacity.account?.city != null) {
      await this.valueService.getUbication(paymentCapacity.account?.city).then(ubic => {
        this.c5 = this.d.find(x => x.valueId === ubic.departmentId).cities;
        this.l5 = this.c5.find(x => x.valueId === ubic.cityId).localities;
        this.department4.setValue(ubic.departmentId);
        this.city4.setValue(ubic.cityId);
        this.location4.setValue(ubic.localityId);
      }).catch(error => this.handleError(error));
    }

    if(paymentCapacity.spouse?.city != null) {
      await this.valueService.getUbication(paymentCapacity.spouse?.city).then(ubic => {
        this.c2 = this.d.find(x => x.valueId === ubic.departmentId).cities;
        this.department1.setValue(ubic.departmentId);
        this.city1.setValue(ubic.cityId);
        this.location1.setValue(ubic.localityId);

      }).catch(error => this.handleError(error));
    }

    const payment = {

      id: paymentCapacity.id,
      transfer: paymentCapacity.transfer === null ? null : paymentCapacity.transfer === true ? 'Si' : 'No',
      role: paymentCapacity.role.valueId,
      debtor: paymentCapacity.debtor.valueId,
      contractNumber: paymentCapacity.contractNumber,
      quotaNumber: paymentCapacity.quotaNumber,
      name: paymentCapacity.applicant?.name,
      lastName: paymentCapacity.applicant?.lastName,
      surname: paymentCapacity.applicant?.surname,
      typeOfIdentity: paymentCapacity.applicant?.typeOfIdentity,
      documentNumber: paymentCapacity.applicant?.documentNumber,
      expeditionDate: setDateStructure(paymentCapacity.applicant?.expDate),
      expeditionDepartment: this.expeditionDepartment.value ?? null,
      expeditionCity: this.expeditionCity.value ?? null,
      sex: paymentCapacity.applicant?.sex?.valueId,
      dateOfBirth: setDateStructure(paymentCapacity.applicant?.dateOfBirth),
      nationality: paymentCapacity.applicant?.nacionality?.valueId,
      civilStatus: paymentCapacity.applicant?.civilStatus?.valueId,
      academicLevel: paymentCapacity.applicant?.academicLevel?.valueId,
      profession: paymentCapacity.applicant?.profession?.valueId,
      otherProfession: paymentCapacity.applicant?.otherProfession,
      minorLoad: paymentCapacity.applicant?.dependentsOver18,
      higherLoad: paymentCapacity.applicant?.dependentsUnder18,
      housing: paymentCapacity.applicant?.housingType?.valueId,
      rent: paymentCapacity.applicant?.declareRent === null ? null : paymentCapacity.applicant?.declareRent === true ? 'Si' : 'No',
      address: paymentCapacity.applicant.address,
      country: paymentCapacity.applicant.country,
      department: this.department.value ?? null,
      city: this.city.value ?? null,
      cityOtherCountries: paymentCapacity.applicant?.cityOtherCountries,
      location: this.location.value ?? null,
      stratum: paymentCapacity.applicant?.stratumSE?.valueId,
      yearsResidence: paymentCapacity.applicant?.yearsInResidence ? String(paymentCapacity.applicant.yearsInResidence) : null,
      phone: String(paymentCapacity.applicant?.phone),
      cellular: String(paymentCapacity.applicant?.cellPhone),
      email: paymentCapacity.applicant?.email,
      emailAlt: paymentCapacity.applicant?.emailAlt,
      name1: paymentCapacity.spouse?.name,
      lastName1: paymentCapacity.spouse?.lastName,
      surname1: paymentCapacity.spouse?.surname,
      typeOfIdentity1: paymentCapacity.spouse?.typeOfIdentity,
      documentNumber1: paymentCapacity.spouse?.documentNumber,
      dateOfBirth1: setDateStructure(paymentCapacity.spouse?.dateOfBirth),
      sex1: paymentCapacity.spouse?.sex.valueId,
      chevyPlan1: paymentCapacity.spouse?.relationship === null ? null : paymentCapacity.spouse?.relationship === true ? 'Si' : 'No',
      address1: stringAddressToObj(paymentCapacity.spouse?.address),
      department1: this.department1.value ?? null,
      city1: this.city1.value ?? null,
      location1: this.location1.value ?? null,
      phone1: String(paymentCapacity.spouse?.phone),
      cellular1: String(paymentCapacity.spouse?.cellPhone),
      activities1: paymentCapacity.spouse?.spounseEconomicActivity,
      job: paymentCapacity.ecoActivApplicant?.job?.valueId,
      ciiu: paymentCapacity.ecoActivApplicant.ciiuCode?paymentCapacity.ecoActivApplicant.ciiuCode.valueId:null,
      whichJob: paymentCapacity.ecoActivApplicant?.whichJob,
      business: paymentCapacity.ecoActivApplicant?.companyName,
      antiquity: paymentCapacity.ecoActivApplicant?.antiquity?.valueId,
      position: paymentCapacity.ecoActivApplicant?.position?.valueId,
      whichPosition: paymentCapacity.ecoActivApplicant?.whichPosition,
      chevyPlan: paymentCapacity.ecoActivApplicant?.relationship === null ? null : paymentCapacity.ecoActivApplicant.relationship === true ? 'Si' : 'No',
      contract: paymentCapacity.ecoActivApplicant?.contract?.valueId,
      whichContract: paymentCapacity.ecoActivApplicant?.whichContract,
      address2: stringAddressToObj(paymentCapacity.ecoActivApplicant?.address),
      department2: this.department2.value ?? null,
      city2: this.city2.value ?? null,
      location2: this.location2.value ?? null,
      phone2: String(paymentCapacity.ecoActivApplicant?.phones),
      cellular2: String(paymentCapacity.ecoActivApplicant?.cellPhones),
      activities2: paymentCapacity.ecoActivApplicant?.ecoActivIndependent,
      composition: paymentCapacity.ecoActivApplicant?.composition?.valueId,
      sectorActivity: paymentCapacity.ecoActivApplicant?.sector?.valueId,
      chamberOfCommerce: paymentCapacity.ecoActivApplicant?.chamberOfCommerce === null ? null : paymentCapacity.ecoActivApplicant?.chamberOfCommerce === true ? 'Si' : 'No',
      employees: paymentCapacity.ecoActivApplicant?.numEmployees ? String(paymentCapacity.ecoActivApplicant.numEmployees) : null,
      participation: paymentCapacity.ecoActivApplicant?.numPartCompany ? String(paymentCapacity.ecoActivApplicant?.numPartCompany) : null,
      monthlyIncome: paymentCapacity.financialInfo?.monthlyIncome ? String(paymentCapacity.financialInfo.monthlyIncome) : '0',
      otherIncome: paymentCapacity.financialInfo?.otherMonthlyIncome ? String(paymentCapacity.financialInfo?.otherMonthlyIncome) : '0',
      descriptionOtherIncome: paymentCapacity?.financialInfo.descripOtherMI,
      totalIncome: paymentCapacity.financialInfo?.totalIncome ? String(paymentCapacity.financialInfo?.totalIncome) : '0',
      totalExpenses: paymentCapacity.financialInfo.totalExpenses ? String(paymentCapacity.financialInfo.totalExpenses) : '0',
      totalAssets: paymentCapacity.financialInfo.totalAssets ? String(paymentCapacity.financialInfo.totalAssets) : '0',
      assetsDetail: paymentCapacity.financialInfo.assetsDetail ? JSON.parse(paymentCapacity.financialInfo.assetsDetail) as any : '0',
      totalPassive: paymentCapacity.financialInfo.totalPassive ? String(paymentCapacity.financialInfo.totalPassive) : '0',
      idReference3:paymentCapacity.references[0]?.id,
      reference3: paymentCapacity.references[0]?.refType?.valueId ? paymentCapacity.references[0]?.refType?.valueId : '1',
      name3: paymentCapacity.references[0]?.name,
      relation3: paymentCapacity.references[0]?.relationship?.valueId,
      address3: stringAddressToObj(paymentCapacity.references[0]?.address),
      department3: this.department3.value ?? null,
      city3: this.city3.value ?? null,
      phone3: String(paymentCapacity.references[0]?.phone),
      cellular3: String(paymentCapacity.references[0]?.cellPhone),
      reference31: paymentCapacity.references[1]?.refType?.valueId ? paymentCapacity.references[1]?.refType?.valueId : '3',
      idReference31:paymentCapacity.references[1]?.id,
      name31: paymentCapacity.references[1]?.name,
      relation31: paymentCapacity.references[1]?.relationship?.valueId,
      address31: stringAddressToObj(paymentCapacity.references[1]?.address),
      department31: this.department31.value ?? null,
      city31: this.city31.value ?? null,
      phone31: String(paymentCapacity.references[1]?.phone),
      cellular31: String(paymentCapacity.references[1]?.cellPhone),
      reference32:  paymentCapacity.ecoActivApplicant?.job?.valueId == "3" ? '4' : '2',
      idReference32:paymentCapacity.references.length > 2 ? paymentCapacity.references[2]?.id:0,
      name32: paymentCapacity.references.length > 2 ? paymentCapacity.references[2]?.name : null,
      relation32: paymentCapacity.references[2]?.relationship?.valueId,
      address32: stringAddressToObj(paymentCapacity.references[2]?.address),
      department32: this.department32.value ?? null,
      city32: paymentCapacity.references[2]?.city,
      phone32: String(paymentCapacity.references[2]?.phone),
      cellular32: String(paymentCapacity.references[2]?.cellPhone),
      automaticDebit: paymentCapacity.account?.financialEntity ? true : false,
      hasSecondHolder: paymentCapacity.account?.secondHolder ? true : false,
      name4: paymentCapacity.account?.secondHolder?.name,
      lastName4: paymentCapacity.account?.secondHolder?.lastName,
      sureName4: paymentCapacity.account?.secondHolder?.sureName,
      typeOfIdentity4: paymentCapacity.account?.secondHolder?.typeOfIdentity,
      documentNumber4: paymentCapacity.account?.secondHolder?.documentNumber,
      expeditionDate4: setDateStructure(paymentCapacity.account?.secondHolder?.expDate),
      expeditionDepartment4: null,
      expeditionCity4: paymentCapacity.account?.secondHolder?.city,
      sex4: paymentCapacity.account?.secondHolder?.sex?.valueId,
      address4: stringAddressToObj(paymentCapacity.account?.secondHolder?.address),
      phone4: String(paymentCapacity.account?.secondHolder?.phone),
      cellular4: String(paymentCapacity.account?.secondHolder?.cellPhone),
      email4: paymentCapacity.account?.secondHolder?.email,
      bank: paymentCapacity.account?.financialEntity?.valueId,
      accountNumber: paymentCapacity.account?.accountNumber,
      accountType: paymentCapacity.account?.accountType?.valueId,
      department4: this.department4.value ?? null,
      city4: this.city4.value ?? null,
      location4: this.location4.value ?? null,
      debitFrom: paymentCapacity.account?.debitFrom?.valueId,
      sameHolder: paymentCapacity.account?.sameHolder === null ? null : paymentCapacity.account?.sameHolder  === true ? "Si" : "No",
      peps1: paymentCapacity.peps.pepsResponse1 === null ? null : paymentCapacity.peps.pepsResponse1 === true ? 'Si' : 'No',
      pepsDesc1: paymentCapacity.peps.pepsDescription1,
      peps2: paymentCapacity.peps.pepsResponse2 === null ? null : paymentCapacity.peps.pepsResponse2 === true ? 'Si' : 'No',
      pepsDesc2: paymentCapacity.peps.pepsDescription2,
      peps3: paymentCapacity.peps.pepsResponse3 === null ? null : paymentCapacity.peps.pepsResponse3 === true ? 'Si' : 'No',
      pepsDesc3: paymentCapacity.peps.pepsDescription3,
      peps4: paymentCapacity.peps.pepsResponse4 === null ? null : paymentCapacity.peps.pepsResponse4 === true ? 'Si' : 'No',
      pepsDesc4: paymentCapacity.peps.pepsDescription4,
      sourceOfIncome: paymentCapacity.peps.sourceOfIncome,
      name5: paymentCapacity.authorizeDeclare.name,
      documentNumber5: paymentCapacity.authorizeDeclare.documentNumber,
      inName: paymentCapacity.authorizeDeclare.inName,
      thirdName: paymentCapacity.authorizeDeclare.thirdName,
      thirdDocumentNumber: paymentCapacity.authorizeDeclare.thirdDocumentNumber
    }



    if(paymentCapacity.spouse?.address)
      this.direcciones.push({id:"address1","direccion":paymentCapacity.spouse?.address})

    if(paymentCapacity.ecoActivApplicant?.address)
      this.direcciones.push({id:"address2","direccion":paymentCapacity.ecoActivApplicant?.address})

    if(paymentCapacity.references[0]?.address)
      this.direcciones.push({id:"address3","direccion":paymentCapacity.references[0]?.address})

    if(paymentCapacity.references[1]?.address)
      this.direcciones.push({id:"address31","direccion":paymentCapacity.references[1]?.address})

    if(paymentCapacity.references[2]?.address)
      this.direcciones.push({id:"address32","direccion":paymentCapacity.references[2]?.address})

    if(paymentCapacity.account?.secondHolder?.address)
      this.direcciones.push({id:"address4","direccion":paymentCapacity.account?.secondHolder?.address})

    if(paymentCapacity.peps?.pepsResponse1 != null)
      this.peps1.setValue(paymentCapacity.peps.pepsResponse1 === null ? null : paymentCapacity.peps.pepsResponse1 === true ? 'Si' : 'No');

    if(paymentCapacity.peps?.pepsResponse1)
      this.pepsDesc1.setValue(paymentCapacity.peps.pepsDescription1 === null ? '' : paymentCapacity.peps.pepsDescription1)

    if(paymentCapacity.peps?.pepsResponse2 != null)
      this.peps2.setValue(paymentCapacity.peps.pepsResponse2 === null ? null : paymentCapacity.peps.pepsResponse2 === true ? 'Si' : 'No');

    if(paymentCapacity.peps?.pepsResponse2)
      this.pepsDesc2.setValue(paymentCapacity.peps.pepsDescription2 === null ? '' : paymentCapacity.peps.pepsDescription2)

    if(paymentCapacity.peps?.pepsResponse3 != null)
      this.peps3.setValue(paymentCapacity.peps.pepsResponse3 === null ? null : paymentCapacity.peps.pepsResponse3 === true ? 'Si' : 'No');

    if(paymentCapacity.peps?.pepsResponse3)
      this.pepsDesc3.setValue(paymentCapacity.peps.pepsDescription3 === null ? '' : paymentCapacity.peps.pepsDescription3)

    if(paymentCapacity.peps?.pepsResponse4 != null)
      this.peps4.setValue(paymentCapacity.peps.pepsResponse4 === null ? null : paymentCapacity.peps.pepsResponse4 === true ? 'Si' : 'No');

    if(paymentCapacity.peps?.pepsResponse4)
      this.pepsDesc4.setValue(paymentCapacity.peps.pepsDescription4 === null ? '' : paymentCapacity.peps.pepsDescription4)

    if(paymentCapacity.peps?.sourceOfIncome != null)
      this.sourceOfIncome.setValue(paymentCapacity.peps.sourceOfIncome === null ? '' : paymentCapacity.peps.sourceOfIncome)

    this.forma.patchValue(payment);
    this.startDate.setValue(this.hoy);
  }

  addressConstruction(id,address) {
      const street=address.street??'';
      const streetNumber=address.streetNumber??'';
      const houseNumber=address.houseNumber??'';
      const oficeNumber=address.oficeNumber??'';
      const apartment=address.apartment??'';
      const apartmentNumber = address.apartmentNumber??'';
      const neighborhood=address.neighborhood??'';
      const neighborhoodField=address.neighborhoodField??'';
      const dir: Direction = {
        id: id,
        direccion: `${street} ${streetNumber} ${houseNumber} ${oficeNumber} ${apartment} ${apartmentNumber} ${neighborhood} ${neighborhoodField}`,
      };
      return dir;

  }

  initFormAdress32(){
    this.address32.get('street').setValue("");
    this.address32.get('streetNumber').setValue("");
    this.address32.get('houseNumber').setValue("");
    this.address32.get('oficeNumber').setValue("");
    this.address32.get('apartmentNumber').setValue("");
    this.address32.get('apartment').setValue("");
    this.address32.get('neighborhood').setValue("");
    this.address32.get('neighborhoodField').setValue("");
  }




  get id() { return this.forma.get('id'); }
  get startDate() { return this.forma.get('startDate'); }
  get transfer() { return this.forma.get('transfer'); }
  get role() { return this.forma.get('role'); }
  get debtor() { return this.forma.get('debtor'); }
  get contractNumber() { return this.forma.get('contractNumber'); }
  get quotaNumber() { return this.forma.get('quotaNumber'); }
  get name() { return this.forma.get('name'); }
  get lastName() { return this.forma.get('lastName'); }
  get surname() { return this.forma.get('surname'); }
  get typeOfIdentity() { return this.forma.get('typeOfIdentity'); }
  get documentNumber() { return this.forma.get('documentNumber'); }
  get expeditionDate() { return this.forma.get('expeditionDate'); }
  get expeditionDepartment() { return this.forma.get('expeditionDepartment'); }
  get expeditionCity() { return this.forma.get('expeditionCity'); }
  get sex() { return this.forma.get('sex'); }
  get dateOfBirth() { return this.forma.get('dateOfBirth'); }
  get nationality() { return this.forma.get('nationality'); }
  get civilStatus() { return this.forma.get('civilStatus'); }
  get academicLevel() { return this.forma.get('academicLevel'); }
  get profession() { return this.forma.get('profession'); }
  get minorLoad() { return this.forma.get('minorLoad'); }
  get higherLoad() { return this.forma.get('higherLoad'); }
  get housing() { return this.forma.get('housing'); }
  get rent() { return this.forma.get('rent'); }
  get address() { return this.forma.get('address'); }
  get country() { return this.forma.get('country'); }
  get department() { return this.forma.get('department'); }
  get city() { return this.forma.get('city'); }
  get location() { return this.forma.get('location'); }
  get stratum() { return this.forma.get('stratum'); }
  get yearsResidence() { return this.forma.get('yearsResidence'); }
  get phone() { return this.forma.get('phone'); }
  get cellular() { return this.forma.get('cellular'); }
  get email() { return this.forma.get('email'); }
  get emailAlt() { return this.forma.get('emailAlt'); }
  get cityOtherCountries() { return this.forma.get('cityOtherCountries'); }
  get name1() { return this.forma.get('name1'); }
  get lastName1() { return this.forma.get('lastName1'); }
  get surname1() { return this.forma.get('surname1'); }
  get typeOfIdentity1() { return this.forma.get('typeOfIdentity1'); }
  get documentNumber1() { return this.forma.get('documentNumber1'); }
  get dateOfBirth1() { return this.forma.get('dateOfBirth1'); }
  get sex1() { return this.forma.get('sex1'); }
  get chevyPlan1() { return this.forma.get('chevyPlan1'); }
  get address1() { return this.forma.get('address1'); }
  get department1() { return this.forma.get('department1'); }
  get city1() { return this.forma.get('city1'); }
  get location1() { return this.forma.get('location1'); }
  get phone1() { return this.forma.get('phone1'); }
  get cellular1() { return this.forma.get('cellular1'); }
  get activities1() { return this.forma.get('activities1'); }
  get ciiu() { return this.forma.get('ciiu'); }
  get job() { return this.forma.get('job'); }
  get whichJob() { return this.forma.get('whichJob'); }
  get business() { return this.forma.get('business'); }
  get antiquity() { return this.forma.get('antiquity'); }
  get position() { return this.forma.get('position'); }
  get whichPosition() { return this.forma.get('whichPosition'); }
  get chevyPlan() { return this.forma.get('chevyPlan'); }
  get contract() { return this.forma.get('contract'); }
  get whichContract() { return this.forma.get('whichContract'); }
  get address2() { return this.forma.get('address2'); }
  get department2() { return this.forma.get('department2'); }
  get city2() { return this.forma.get('city2'); }
  get location2() { return this.forma.get('location2'); }
  get phone2() { return this.forma.get('phone2'); }
  get cellular2() { return this.forma.get('cellular2'); }
  get activities2() { return this.forma.get('activities2'); }
  get composition() { return this.forma.get('composition'); }
  get sectorActivity() { return this.forma.get('sectorActivity'); }
  get chamberOfCommerce() { return this.forma.get('chamberOfCommerce'); }
  get employees() { return this.forma.get('employees'); }
  get participation() { return this.forma.get('participation'); }
  get monthlyIncome() { return this.forma.get('monthlyIncome'); }
  get otherIncome() { return this.forma.get('otherIncome'); }
  get descriptionOtherIncome() { return this.forma.get('descriptionOtherIncome'); }
  get totalIncome() { return this.forma.get('totalIncome'); }
  get totalExpenses() { return this.forma.get('totalExpenses'); }
  get totalAssets() { return this.forma.get('totalAssets'); }
  get assetsDetail() { return this.forma.get('assetsDetail'); }
  get totalPassive() { return this.forma.get('totalPassive'); }
  get reference3() { return this.forma.get('reference3'); }
  get idReference3() { return this.forma.get('idReference3'); }
  get name3() { return this.forma.get('name3'); }
  get relation3() { return this.forma.get('relation3'); }
  get address3() { return this.forma.get('address3'); }
  get department3() { return this.forma.get('department3'); }
  get city3() { return this.forma.get('city3'); }
  get phone3() { return this.forma.get('phone3'); }
  get cellular3() { return this.forma.get('cellular3'); }
  get reference31() { return this.forma.get('reference31'); }
  get name31() { return this.forma.get('name31'); }
  get relation31() { return this.forma.get('relation31'); }
  get idReference31() { return this.forma.get('idReference31'); }
  get address31() { return this.forma.get('address31'); }
  get department31() { return this.forma.get('department31'); }
  get city31() { return this.forma.get('city31'); }
  get phone31() { return this.forma.get('phone31'); }
  get cellular31() { return this.forma.get('cellular31'); }
  get reference32() { return this.forma.get('reference32'); }
  get idReference32() { return this.forma.get('idReference32'); }
  get name32() { return this.forma.get('name32'); }
  get relation32() { return this.forma.get('relation32'); }
  get address32() { return this.forma.get('address32'); }
  get department32() { return this.forma.get('department32'); }
  get city32() { return this.forma.get('city32'); }
  get phone32() { return this.forma.get('phone32'); }
  get cellular32() { return this.forma.get('cellular32'); }
  get automaticDebit() { return this.forma.get('automaticDebit'); }
  get hasSecondHolder() { return this.forma.get('hasSecondHolder'); }
  get name4() { return this.forma.get('name4'); }
  get lastName4() { return this.forma.get('lastName4'); }
  get sureName4() { return this.forma.get('sureName4'); }
  get typeOfIdentity4() { return this.forma.get('typeOfIdentity4'); }
  get documentNumber4() { return this.forma.get('documentNumber4'); }
  get expeditionDate4() { return this.forma.get('expeditionDate4'); }
  get expeditionDepartment4() { return this.forma.get('expeditionDepartment4'); }
  get expeditionCity4() { return this.forma.get('expeditionCity4'); }
  get sex4() { return this.forma.get('sex4'); }
  get address4() { return this.forma.get('address4'); }
  get phone4() { return this.forma.get('phone4'); }
  get cellular4() { return this.forma.get('cellular4'); }
  get email4() { return this.forma.get('email4'); }
  get bank() { return this.forma.get('bank'); }
  get accountNumber() { return this.forma.get('accountNumber'); }
  get accountType() { return this.forma.get('accountType'); }
  get department4() { return this.forma.get('department4'); }
  get city4() { return this.forma.get('city4'); }
  get location4() { return this.forma.get('location4'); }
  get debitFrom() { return this.forma.get('debitFrom'); }
  get peps1() { return this.forma.get('peps1'); }
  get pepsDesc1() { return this.forma.get('pepsDesc1'); }
  get peps2() { return this.forma.get('peps2'); }
  get pepsDesc2() { return this.forma.get('pepsDesc2'); }
  get peps3() { return this.forma.get('peps3'); }
  get pepsDesc3() { return this.forma.get('pepsDesc3'); }
  get peps4() { return this.forma.get('peps4'); }
  get pepsDesc4() { return this.forma.get('pepsDesc4'); }
  get sourceOfIncome() { return this.forma.get('sourceOfIncome'); }
  get name5() { return this.forma.get('name5'); }
  get documentNumber5() { return this.forma.get('documentNumber5'); }
  get inName() { return this.forma.get('inName'); }
  get thirdName() { return this.forma.get('thirdName'); }
  get thirdDocumentNumber() { return this.forma.get('thirdDocumentNumber'); }
  get otherProfession() { return this.forma.get('otherProfession'); }
  get sameHolder() { return this.forma.get('sameHolder'); }
}
